import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import GameIcon from 'components/GameIcon';
import './GameLink.css';

function GameLink({
  game,
  className,
  iconComponent = GameIcon,
  ...otherProps
}) {
  const IconComponent = iconComponent;
  return (
    game && (
      <div className={`game-link ${className || ''}`} {...otherProps}>
        <Link to={`/game/${game.slug}`} draggable="false">
          <IconComponent
            game={game}
            badge={game.badge}
            alt={game.displayName}
          />
        </Link>
      </div>
    )
  );
}

GameLink.propTypes = {
  game: PropTypes.object,
  className: PropTypes.string
};

export default GameLink;
